import React, { ChangeEvent, useEffect } from "react";
import { Field, useField, useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

interface CriticalResidueInputProps {
    name: string;
    placeholder: string;
    label?: React.ReactNode;
    maxLength?: number;
    textTooltip?: string;
    id: string;
    isDisabled?: boolean;
    isMoveAll?: boolean;
    isAllowZero?: boolean;
}

const QuantityInput: React.FC<CriticalResidueInputProps> = ({
    name,
    placeholder,
    maxLength,
    id,
    isDisabled,
    isMoveAll,
    isAllowZero = false,
}) => {
    const resolvedMaxLength = maxLength ?? 9;
    const { t } = useTranslation();
    const { setFieldValue, setFieldTouched } = useFormikContext();
    const [field, meta] = useField(name);

    const handleCriticalResidueChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.trim();
        let isValid = false;
        if (isAllowZero) {
            isValid = /^(0|[1-9]\d*)$/.test(value) || value === "";
        } else {
            isValid = /^[1-9]\d*$/.test(value) || value === "";
        }

        const parsedValue = value === "" ? null : value;

        if (isValid) {
            setFieldValue(name, parsedValue, true);
        }
    };

    const handleBlurCriticalResidue = () => {
        const numeric = parseInt(field.value, 10);

        if (!field.value || isNaN(numeric) || (!isAllowZero && numeric <= 0) || (isAllowZero && numeric < 0)) {
            setFieldValue(name, null);
        } else {
            setFieldValue(name, numeric);
        }
        setFieldTouched(name, true);
    };

    useEffect(() => {
        if (isMoveAll) {
            setFieldValue(name, null);
        }
    }, [isMoveAll, name, setFieldValue]);

    return (
        <>
            <Field
                name={name}
                id={id}
                type="text"
                placeholder={t(placeholder)}
                className={`form-control fs-7 text-dark ${meta.touched && meta.error ? "is-invalid" : ""}`}
                value={field.value !== null && field.value !== undefined ? field.value : ""}
                onChange={handleCriticalResidueChange}
                onBlur={handleBlurCriticalResidue}
                disabled={isDisabled}
                maxLength={resolvedMaxLength}
            />
        </>
    );
};

export default QuantityInput;
